import React from 'react';
import { useHistory } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const history = useHistory();

  const handleGoHome = () => {
    history.push('/');
  };

  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <div className="notfound-icon">
          <span className="icon-404">404</span>
        </div>
        
        <h1 className="notfound-title">Page Not Found</h1>
        
        <p className="notfound-message">
          Oops! The page you're looking for doesn't exist.
        </p>
        
        <p className="notfound-submessage">
          The URL you entered might be incorrect or the page may have been moved.
        </p>

        <button 
          className="notfound-home-btn"
          onClick={handleGoHome}
        >
          Go to Homepage
        </button>

        {/* <div className="notfound-help">
          <p>Need help? Contact us at <a href="mailto:test@spiritaircargohandling.dk">test@spiritaircargohandling.dk</a></p>
        </div> */}
      </div>
    </div>
  );
};

export default NotFound;
